module.exports = {"id":"dp5_1l3q4","text":"Device performance","instructions":"Adjusting device settings can improve performance issues.","multiselect":false,"category":"5.1","questionType":"PickOne","random":false,"options":[{"id":"dp5_1l3q4-a1","text":"True","score":3.7},{"id":"dp5_1l3q4-a2","text":"Not sure","score":1.3},{"id":"dp5_1l3q4-a3","text":"False","score":1.3}],"groupTitle":"Digital Profiler Knowledge Matrix"}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat5.1/l3q4.json
// module id = 1289
// module chunks = 41